import { useNavigate } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const navigate = useNavigate();

  return (
    <nav aria-label="面包屑导航" className="py-3">
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1">
            {index > 0 && (
              <span className="text-foreground-500 mx-1">/</span>
            )}
            {item.href ? (
              <a
                href={item.href}
                onClick={(e) => { e.preventDefault(); navigate(item.href!); }}
                className="text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
              >
                {item.label}
              </a>
            ) : (
              <span className="text-foreground-50 font-medium whitespace-nowrap">
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}